<script>
  import { createEventDispatcher } from 'svelte';

    export let currentPage = 1;
    export let totalPages = 1;

    const dispatch = createEventDispatcher();

    function prevPage() {
    if (currentPage > 1) {
        dispatch('change', --currentPage);
    }
    }

    function nextPage() {
    if (currentPage < totalPages) {
        dispatch('change', ++currentPage);
    }
    }
</script>

<div class="pagination-controls">
    {#if currentPage > 1}
    <button 
        class="prev"
        on:click={prevPage} 
        disabled={currentPage <= 1}
        aria-label="Go to page {currentPage-1} of {totalPages}." >
        <svg aria-hidden="true" width="10" height="10" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="svelte-1j8lu64">
            <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"></path>
        </svg>
    </button>
    {/if}
    <span>Page {currentPage} of {totalPages}</span>
    {#if currentPage < totalPages}
    <button 
        class="next"
        on:click={nextPage} 
        disabled={currentPage >= totalPages} 
        aria-label="Go to page {currentPage+1} of {totalPages}.">
        <svg aria-hidden="true" width="10" height="10" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="svelte-1j8lu64">
            <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"></path>
        </svg>        
    </button>
    {/if}
</div>